import * as XLSX from 'xlsx';

const TEMPLATE_HEADERS = ['name', 'phone', 'country_code', 'tags', 'notes'] as const;

const SAMPLE_ROWS: string[][] = [
  TEMPLATE_HEADERS.slice(),
  ['John Doe', '9876543210', '+91', 'vip', 'Follow up call'],
  ['Jane Smith', '9123456780', '+91', 'patient', ''],
];

/** Download sample CSV template for WhatsApp contact import. */
export function downloadWhatsAppContactTemplateCsv(): void {
  const csv = SAMPLE_ROWS.map((row) => row.map((cell) => `"${cell.replace(/"/g, '""')}"`).join(',')).join('\n');
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'vedika-whatsapp-contacts-template.csv';
  link.click();
  URL.revokeObjectURL(url);
}

/** Download sample Excel template for WhatsApp contact import. */
export function downloadWhatsAppContactTemplateExcel(): void {
  const sheet = XLSX.utils.aoa_to_sheet(SAMPLE_ROWS);
  sheet['!cols'] = [{ wch: 24 }, { wch: 16 }, { wch: 14 }, { wch: 16 }, { wch: 28 }];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'Contacts');
  XLSX.writeFile(workbook, 'vedika-whatsapp-contacts-template.xlsx');
}
